/* eslint-disable react/no-array-index-key */
import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import TdsTcsActions from '@Actions/configurations/tdsTcsActions';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

const SelectTaxType = ({
  user, tdsTcs, onChange, selectedTaxType, disabled, showError, title, getTdsTcsLoading, customStyle, getPopupContainer, open, errorOutline, containerClassName, notRequired, taxTypeName, getTdsTcs,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);

  useEffect(() => {
    if (taxTypeName && !isUserReady) {
      getTdsTcs();
      setIsUserReady(true);
    }
  }, [taxTypeName]);

  return (
    <div className={containerClassName}>
      {title
        ? (
          <label className="orgFormLabel">
            {title}
            {notRequired ? '' : <span style={{ color: 'red' }}>{'  *'}</span>}
          </label>
        )
        : <label />}
      <PRZSelect
        getPopupContainer={getPopupContainer}
        value={!getTdsTcsLoading && (selectedTaxType || '')}
        open={open}
        filterOption={false}
        disabled={disabled || getTdsTcsLoading}
        onChange={(value) => onChange(tdsTcs?.data.filter((item) => item?.tax_id === value)[0])}
        style={{
          border: errorOutline ? '1px solid red' : 'none',
          borderRadius: '2px',
          height: '28px',
          width: '100%',
          fontSize: '13px',
          ...customStyle,
        }}
        allowClear
        showError={showError}
        errorName="*Please select tax description"
        errorClassName="formError"
      >
        {tdsTcs?.data?.filter((item) => (taxTypeName ? item?.tax_type_name === taxTypeName : true))?.map((item) => (
          <Option key={item?.tax_id} value={item?.tax_id}>
            {`${item?.tax_value}% - ${item?.tax_name}`}
          </Option>
        ))}
      </PRZSelect>
    </div>

  );
};

const mapStateToProps = ({ UserReducers, TdsTcsReducers }) => ({
  user: UserReducers.user,
  getTdsTcsLoading: TdsTcsReducers.updateTdsTcsLoading,
  tdsTcs: TdsTcsReducers.tdsTcs,
});

const mapDispatchToProps = (dispatch) => ({
  getTdsTcs: (taxName) => dispatch(TdsTcsActions.getTdsTcs(taxName)),
});

SelectTaxType.propTypes = {
  user: PropTypes.any,
  tdsTcs: PropTypes.any,
  selectedTaxType: PropTypes.any,
  getTdsTcs: PropTypes.func,
  getTdsTcsLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  taxTypeName: PropTypes.any,
  title: PropTypes.any,
  customStyle: PropTypes.any,
  errorOutline: PropTypes.any,
  getPopupContainer: PropTypes.any,
  open: PropTypes.any,
  containerClassName: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectTaxType));
